import { autoinject, Aurelia } from 'aurelia-framework';
import { AppRouter, RouteConfig, NavigationInstruction } from 'aurelia-router';
import { ValidationRules, validateTrigger, ValidationControllerFactory } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation/bootstrap-form-renderer';
import { AuthService } from 'aurelia-authentication';

@autoinject
export class Register {

	showErrorMessage: boolean = false;
	errorMessage:string;
	title = "Register";
	validation: any;
	user: any = { email: null, password: null, confirmPassword:null, team: null, first:null, last:null };
	constructor(
		private authService: AuthService,
		private router: AppRouter,
		validationFactory: ValidationControllerFactory,
		//private httpClient: HttpClient,
		//private accountService: AccountService,
		private aurelia: Aurelia
	) {
		this.validation = validationFactory.createForCurrentScope();
		this.validation.addRenderer(new BootstrapFormRenderer());
		this.validation.validateTrigger = validateTrigger.change;
	}
	async activate(params: any, routeConfig: RouteConfig, navigationInstruction: NavigationInstruction) {

	}

	async register() {

		try {
			const response = await this.authService.signup(this.user);
			console.log("success logged " + response);
			this.navigateToHomeRoute();
		}

		catch (response) {
			const data = await response.json()
			this.showErrorMessage = true;
			this.errorMessage = data.message;
		}		
	}


	async navigateToHomeRoute() {
		this.router.navigate('');
	}

}




